module.exports = __webpack_public_path__ + "img/study_content_rankavatar.285e1eef.png";